/**
 * @param eventName
 * @param target
 */
function CreateEvent(eventName: string): Event {
  const newEvent = document.createEvent('Event');

  newEvent.initEvent(eventName, true, true);

  return newEvent;
}

/**
 * @param option
 * @param option.maxQueueSize
 */
function Queue({ maxQueueSize = 0 }) {
  const data = new Map();

  let newestElementIndex = 0;
  let oldestElementIndex = 0;

  /**
   * Get all data from queue
   */
  function getData() {
    return data;
  }

  /**
   * Get queue size
   */
  function getSize() {
    return data.size;
  }

  /**
   * Remove oldest element from queue
   *
   * @returns Return deleted data
   */
  function dequeue() {
    if (oldestElementIndex !== newestElementIndex) {
      data.delete(oldestElementIndex);
      oldestElementIndex = oldestElementIndex + 1;
    }
  }

  /**
   * Add element to queue
   *
   * @param element
   */
  function enqueue(element: any) {
    if (maxQueueSize !== getSize() || maxQueueSize === 0) {
      data.set(newestElementIndex, element);
      newestElementIndex = newestElementIndex + 1;
    } else {
      dequeue();
      enqueue(element);
    }
  }

  /**
   * Clear queue
   */
  function clear() {
    data.clear();
    newestElementIndex = 0;
    oldestElementIndex = 0;
  }

  return {
    enqueue,
    dequeue,
    getData,
    getSize,
    clear,
  };
}

export { CreateEvent, Queue };
